/** Pages that work without a session (locale prefix stripped). */
export const PUBLIC_PATHS: readonly string[] = ["/login", "/signup"];
